module.exports = __webpack_public_path__ + "static/media/sjm-circle.d46e3074.png";